import axios from 'axios'
let validation = require('./Validation')

let isMobile = validation.ValidationUtils.methods.isMobile
export const PatientInfoUtils = {
  methods: {
    async getPatientInfo () {
      let info = {
        browser: null,
        ip: null,
        isPhone: null,
        os: null
      }
      // get browser
      info.browser = this.getBrowser()

      // get IP
      await axios.get('https://api.ipify.org?format=json').then((response) => {
        info.ip = response.data.ip
      })

      // check if is mobile
      info.isPhone = isMobile()

      // getOS
      info.os = this.getOS()

      return info
    },
    getBrowser () {
      let userAgent = navigator.userAgent
      let browserName
      if (userAgent.match(/chrome|chromium|crios/i)) {
        browserName = 'chrome'
      } else if (userAgent.match(/firefox|fxios/i)) {
        browserName = 'firefox'
      } else if (userAgent.match(/safari/i)) {
        browserName = 'safari'
      } else if (userAgent.match(/opr\//i)) {
        browserName = 'opera'
      } else if (userAgent.match(/edg/i)) {
        browserName = 'edge'
      } else {
        browserName = 'No browser detection'
      }
      return browserName
    },
    getOS () {
      let userAgent = navigator.userAgent
      let os = null
      if (/(Macintosh|MacIntel|MacPPC|Mac68K)/i.test(userAgent)) {
        os = 'Mac OS'
      } else if (/(iPhone|iPod|iPad)/i.test(userAgent)) {
        os = 'iOS'
      } else if (/(Win32|Win64|Windows"WinCE)/i.test(userAgent)) {
        os = 'Windows'
      } else if (/Android/.test(userAgent)) {
        os = 'Android'
      } else if (!os && /Linux/.test(userAgent)) {
        os = 'Linux'
      }
      return os
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/PatientInfo.js